// UI management for Space Invaders
export class UI {
  constructor() {
    this.scoreEl = document.getElementById('score');
    this.livesEl = document.getElementById('lives');
    this.levelEl = document.getElementById('level');
    this.highscoreEl = document.getElementById('highscore');
    this.btnMute = document.getElementById('btnMute');
    this.btnRestart = document.getElementById('btnRestart');
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Canvas focus conveniences
    const canvas = document.getElementById('gameCanvas');
    if (canvas) {
      canvas.addEventListener('click', () => canvas.focus());
      canvas.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
        }
      });
    }
  }

  updateHUD(gameState) {
    if (!gameState) return;
    
    if (this.scoreEl) this.scoreEl.textContent = 'SCORE: ' + gameState.score;
    if (this.livesEl) this.livesEl.textContent = 'LIVES: ' + gameState.lives;
    if (this.levelEl) this.levelEl.textContent = 'LEVEL: ' + gameState.level;
    if (this.highscoreEl) this.highscoreEl.textContent = 'HIGHSCORE: ' + gameState.highscore;
  }

  // Dramatisk effekt når man mister liv
  triggerLifeLostEffect() {
    // Skjermristing
    this.shakeScreen();
    
    // Flash effekt
    this.flashScreen();
    
    // Pulsing effekt på lives display
    this.pulseLivesDisplay();
  }

  shakeScreen() {
    const canvas = document.getElementById('gameCanvas');
    if (!canvas) return;
    
    const originalTransform = canvas.style.transform;
    let shakeCount = 0;
    const maxShakes = 10;
    
    const shake = () => {
      if (shakeCount >= maxShakes) {
        canvas.style.transform = originalTransform;
        return;
      }
      
      const x = (Math.random() - 0.5) * 8;
      const y = (Math.random() - 0.5) * 8;
      canvas.style.transform = `translate(${x}px, ${y}px)`;
      
      shakeCount++;
      setTimeout(shake, 50);
    };
    
    shake();
  }

  flashScreen() {
    const canvas = document.getElementById('gameCanvas');
    if (!canvas) return;
    
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 50, 50, 0.3);
      pointer-events: none;
      z-index: 1000;
      transition: opacity 0.1s ease-out;
    `;
    
    canvas.parentElement.style.position = 'relative';
    canvas.parentElement.appendChild(overlay);
    
    setTimeout(() => {
      overlay.style.opacity = '0';
      setTimeout(() => {
        if (overlay.parentElement) {
          overlay.parentElement.removeChild(overlay);
        }
      }, 100);
    }, 50);
  }

  pulseLivesDisplay() {
    const livesEl = document.getElementById('lives');
    if (!livesEl) return;
    
    const originalColor = livesEl.style.color;
    let pulseCount = 0;
    const maxPulses = 6;
    
    const pulse = () => {
      if (pulseCount >= maxPulses) {
        livesEl.style.color = originalColor;
        livesEl.style.textShadow = '';
        return;
      }
      
      const intensity = 1 - (pulseCount / maxPulses);
      livesEl.style.color = `rgba(255, 50, 50, ${0.8 + intensity * 0.2})`;
      livesEl.style.textShadow = `
        0 0 ${5 + intensity * 15}px rgba(255, 50, 50, ${0.8 + intensity * 0.2}),
        0 0 ${10 + intensity * 20}px rgba(255, 50, 50, ${0.6 + intensity * 0.4}),
        0 0 ${15 + intensity * 25}px rgba(255, 50, 50, ${0.4 + intensity * 0.6})
      `;
      
      pulseCount++;
      setTimeout(pulse, 100);
    };
    
    pulse();
  }

  // Start Game button removed - game starts automatically

  setMuteButtonCallback(callback) {
    if (this.btnMute) {
      this.btnMute.addEventListener('click', callback);
    }
  }

  setRestartButtonCallback(callback) {
    if (this.btnRestart) {
      this.btnRestart.addEventListener('click', callback);
    }
  }

  updateMuteButton(isMuted) {
    if (this.btnMute) {
      this.btnMute.textContent = isMuted ? 'Unmute' : 'Mute';
    }
  }

  // Auto-update HUD periodically for visual consistency
  startHUDAutoUpdate(gameState) {
    setInterval(() => {
      if (gameState) {
        this.updateHUD(gameState);
      }
    }, 200);
  }
}
